import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, forwardRef } from '@angular/core';
import { NodeViewComponent } from '@examdojo/core/tiptap';
import { SuperLatexComponent, SuperLatexContent } from '@examdojo/super-latex';
import { v4 as uuid } from 'uuid';
import { SuperLatexBlock } from '../../../model';
import { DragWithHandleOnlyDirective } from '../drag-with-handle-only.directive';
import { DEFAULT_SUPER_LATEX_PROPS } from './super-latex.model';

@Component({
  selector: 'dojo-super-latex-node',
  standalone: true,
  imports: [NgClass, NgStyle, SuperLatexComponent],
  templateUrl: './super-latex.component.html',
  hostDirectives: [DragWithHandleOnlyDirective],
  providers: [
    {
      provide: NodeViewComponent,
      useExisting: forwardRef(() => SuperLatexNodeComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuperLatexNodeComponent extends NodeViewComponent<SuperLatexBlock> {
  readonly latexNodes = this.getProp('latex_nodes');
  readonly annotations = this.getProp('annotations');
  readonly connections = this.getProp('connections');
  readonly layout = this.getProp('layout');
  readonly highlightedAnchors = this.getProp('highlighted_anchors');
  readonly customCss = this.getProp('custom_css');
  readonly customStyle = this.getProp('custom_style');

  readonly content = computed<SuperLatexContent>(() => ({
    latex_nodes: this.latexNodes(),
    annotations: this.annotations() ?? undefined,
    connections: this.connections() ?? undefined,
    layout: this.layout() ?? undefined,
    highlighted_anchors: this.highlightedAnchors() ?? undefined,
  }));

  override getDefaults = (): SuperLatexBlock => ({
    ...DEFAULT_SUPER_LATEX_PROPS,
    id: uuid(),
  });
}
